import MapDeliveryInfo from "./MapDeliveryInfo";

export default MapDeliveryInfo